import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import queryString from 'query-string'
import FlexRow from '../../../components/molecules/FlexRow'
import { fromURLSafeBase64 } from '../../../utils/URLSafeBase64'
import FlexColumn from '../../../components/molecules/FlexColumn'
import { connections } from '../../../api/integrations'
import { useGetPendingAuthorizationStatus } from '../../../api/users/authorizations'
import Loading from '../../../components/molecules/Loading'

function CallbackUtility () {
  const { provider } = useParams()
  const location = useLocation()
  const { mutateAsync: resolveAuthorization } = connections.useExchangeConnectionAuthorization()

  const queryParams = queryString.parse(location?.search || '')
  const authorizationId = fromURLSafeBase64(queryParams?.state)
  const code = queryParams?.code
  const realmId = queryParams?.realmId
  const { data: authorizationStatus } = useGetPendingAuthorizationStatus(authorizationId, provider)

  const [completed, setCompleted] = useState(false)
  const handleResolveAuthorization = useCallback(async (authorizationId, purpose, payload, authRequiredFields) => {
    const result = await resolveAuthorization({
      authorizationId,
      fromOrigin: window.location.origin,
      domain: purpose,
      data: {
        ...payload,
        ...authRequiredFields
      }
    })

    if (result?.authorized) {
      setCompleted(true)
      window.close()
    } else if (result?.authorized === false && result.redirect) {
      console.trace('Redirecting to other origin (not normal)')
      const originalURL = new URL(result.redirect)
      if (originalURL.origin !== window.location.origin) {
        const redirectURL = new URL(window.location)
        window.location.href = `${originalURL.origin}${redirectURL.pathname}${redirectURL.search}${redirectURL.hash}`
      }
    } else {
      alert('Not authorized!')
    }
  }, [resolveAuthorization, setCompleted])

  useEffect(() => {
    if (!authorizationStatus) {
      return
    }

    handleResolveAuthorization(
      authorizationId,
      provider,
      {
        code: queryParams?.code,
        realmId: queryParams?.realmId // Specific to QuickBooks
      }
    ).catch(console.error)
  }, [authorizationStatus, handleResolveAuthorization, authorizationId, provider, code, realmId, queryParams?.code, queryParams?.realmId])

  return (
    <FlexRow className='p-xl justify-center' style={{ minHeight: '400px' }}>
      <FlexColumn>
        {completed ? (
          <>
            <div className='font-size-lg'>Authorization Complete</div>
            <div style={{ fontStyle: 'italic' }}>You can close this window</div>
          </>
        ) : (
          <Loading />
        )}
      </FlexColumn>
    </FlexRow>
  )
}

export default CallbackUtility
